import { ClockIcon } from "@heroicons/react/24/outline"

export default function WorkoutLength({ 
    selectedWorkoutLength,
    ShowWorkoutLengthSelectionModal = () => {}
}) {
    return (
        <>
            <p>Workout Length</p>

            <div className='grid grid-cols-2 gap-4'>
                <div 
                    className='px-4 py-2 flex items-center justify-center rounded-xl overflow-hidden text-center gap-x-1 bg-white shadow-md cursor-pointer'
                    onClick={() => ShowWorkoutLengthSelectionModal()}
                >
                    <ClockIcon className='h-6 w-6 m-1 text-gray-500' />

                    <p>{selectedWorkoutLength} mins</p>
                </div>
            </div>
        </>
    )
}